import React from 'react';
import { Outlet, Link } from "react-router-dom";

export default function Club(){
    return(
        <Link to="club" className='text-link'>
            <div className='commonbox club' >
                <p></p>
                <img src= {require('./images/techno.png')} className = "technoimage"></img>
                <div className='techno'>
                    <h1>TechnoInformals</h1>
                    <p>The Entertainment & Management Cluster of SASTRA University.</p>
                    <p>Member</p>
                </div>
                <img src= {require('./images/300dpi.png')} className = "dpiimage"></img>
                <div className='dpi'>
                    
                    <h1>300dpi</h1>
                    <p>Official Design and Development Club of SASTRA University</p>
                    <p>Graphic Designer</p>
                </div>
            </div>
        </Link>
    );
}